import React from "react";
import styled from "styled-components";
import { media } from "../styles/breakpoints";

const HeaderWrapper = styled.div`
  border-bottom-width: 1px;
  min-height: 70px;
  transition: border-color 0.75s, background-color 0.75s;
  flex: 0 0 auto;
  justify-content: center;
  align-content: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  padding: 8px 12px;

  ${media.md`
    min-height: 80px;
    padding: 10px 16px;
  `}

  ${media.lg`
    min-height: 100px;
  `}
`;

const HeaderLogo = styled.img`  
  max-height: 60px;
  margin: 8px auto;
  object-fit: contain;

  ${media.md`   
    max-height: 70px;
  `}

  ${media.lg`   
    max-height: 80px;
  `}
`;

const HeaderTagline = styled.span`
  position: relative;
  font-weight: bold;
  font-size: 12px;
  line-height: 1.3;

  ${media.md`
    font-size: 14px;
  `}
`;

const ServiceBotHeader = ({ logo, tagLine }) => {
  return (
    <HeaderWrapper>
      <HeaderLogo alt="logo" src={logo} />
      <HeaderTagline>{tagLine}</HeaderTagline>
    </HeaderWrapper>
  );
};

export default ServiceBotHeader;
